<template>
  <svg width="25" height="24" viewBox="0 0 25 24">
    <path
      d="M12.779 4.5c1.942.004 3.67.045 4.215.115 1.04.14 1.894.643 2.339 1.565.293.61.846 2.167 1.156 3.65l.721.922c.721.914 1.04 1.664 1.04 3.08v4.217c0 .801-.65 1.451-1.45 1.451h-.35A1.45 1.45 0 0 1 19 18.05l.003-.948c-1.847.111-4.449.19-6.503.19-2.104 0-4.77-.082-6.623-.197L6 17.1v.948c0 .801-.65 1.451-1.45 1.451H4.2a1.45 1.45 0 0 1-1.45-1.45v-4.217c0-1.417.319-2.167 1.04-3.08l.72-.924c.302-1.482.864-3.039 1.15-3.649.443-.922 1.307-1.433 2.346-1.565.562-.066 2.44-.115 4.494-.115zm-6.497 8.114c-.77 0-1.354.57-1.354 1.343 0 .764.583 1.335 1.354 1.335.778 0 1.354-.57 1.354-1.335 0-.772-.576-1.343-1.354-1.343zm12.43 0c-.772 0-1.35.57-1.35 1.343 0 .764.578 1.335 1.35 1.335.781 0 1.359-.57 1.359-1.335 0-.772-.578-1.343-1.359-1.343zm-4.05.37h-4.325c-.57 0-.964.387-.964.948 0 .552.394.939.964.939h4.326c.57 0 .964-.387.964-.94 0-.56-.394-.947-.964-.947zM12.15 5.868c-2.106.004-3.499.05-4.13.13-.48.06-.754.245-.992.648-.28.476-.668 1.593-.877 2.558-.045.18-.005.255.16.258l1.087-.06a88.142 88.142 0 0 1 4.15-.106l1.36-.002 1.364.01c1.417.015 2.533.053 3.656.115l.676.04c.239.019.298-.048.247-.256-.238-1.02-.613-2.117-.876-2.555-.22-.36-.454-.54-.842-.623l-.153-.027-.215-.025c-.597-.06-1.657-.093-3.246-.103l-1.37-.002z"
      :fill="disabled ? '#ccccc9' : color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#1D1D20',
    },
  },
}
</script>
